export var ENTITY = "tag";
export var REDUCER_KEY = "TAG_V2";
export var BASE_PATH_ENTITY = "tags";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
